import { EditOutlined } from "@mui/icons-material";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoanDrilldownChangesForm from "../../../forms/LoanDrilldownChangesForm";
import { useUnderwritingHook } from "../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../redux/actions/loanDrilldownActions";
import BasicModal from "../../modals/BasicModal";
import RffFieldComponentRenderer from "../../finalForm/shared/RffFieldComponentRenderer";
import RffGroup from "../../finalForm/shared/RffGroup";
import { isFunction } from "lodash";

const UpdateLoanRootDataFieldsModal = ({
  onClose,
  loanId,
  borrowerId,
  propertyId,
  show,
  formSpy,
  property,
  children,
  fields,
  onSuccessFn,
  maxWidth = "xs",
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const handleOnClose = useCallback((d) => {
    onClose(false);
    // if (isFunction(onSuccessFn)) {
    //   onSuccessFn(d);
    // }
  }, []);

  const initialValues = useMemo(() => {
    if (borrowerId) {
      return (
        loanDrilldown?.borrowers?.find(
          (borrower) => borrower._id === borrowerId
        ) || {}
      );
    }
    return loanDrilldown;
  }, [loanDrilldown, borrowerId, propertyId]);

  return (
    <BasicModal
      title="Update Loan Fields"
      description={
        property?.address?.fullAddress ? property?.address?.fullAddress : null
      }
      show={show}
      icon={<EditOutlined className="thin" />}
      onClose={handleOnClose}
      bodySx={{ p: 3 }}
      maxWidth={maxWidth}
    >
      <LoanDrilldownChangesForm
        submitText="Update Loan"
        // onSubmit={onSubmit}
        // onCancelText={"Reset"}
        formSpy={formSpy}
        showFooter
        // onCancel={handleOnClose}
        onSuccessFn={handleOnClose}
        data={initialValues}
        // loading={loading}
        borrowerId={borrowerId}
        propertyId={propertyId}
      >
        {/* <RffDollarField name="interestReserves" label="Interest Reserves" /> */}
        {/* {children} */}
        <RffGroup>
          {fields?.map((field) => (
            <RffFieldComponentRenderer
              key={field.name}
              // inputType={field?.type}
              // {...field}
              field={field}
            />
          ))}
        </RffGroup>
      </LoanDrilldownChangesForm>
    </BasicModal>
  );
};

export default UpdateLoanRootDataFieldsModal;
